import PropTypes from 'prop-types';
import React from 'react'

import { submitStatement } from '~/actions/statement'

import MiniLoader from '~/components/Loaders/MiniLoader'

export default class extends React.Component {
    static propTypes = {
		camp: PropTypes.object,
		dispatch: PropTypes.func,
		fetching: PropTypes.bool,
	};

    status = '';

    submitStatement = () => {
		this.props.dispatch( submitStatement(this.refs.status.value, this.props.camp.ID) )
		this.refs.status.value = ''
	};

    render() {
		return (
			<div className="submit-form panel mbot20">
				<div className="col-sm-12 ptop15 pbot15">

		    		<textarea className="form-control submitter mbot15" rows="3" onChange={this.updateStatus} ref="status" placeholder="Ask questions, offer tips and share interesting links"></textarea>

		    		<div className="clearfix"></div>

	    			<button type="submit" className="btn btn-primary pull-right" onClick={this.submitStatement}>
						{ this.props.fetching ? <MiniLoader /> : 'Post' }
	    			</button>
	    			<p className="button-sub-text small ext-dark-gray"><em>{'This will be posted in the ' + this.props.camp.title + ' camp'}</em></p>

	    		</div>
	    		<div className="clearfix"></div>
    		</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/DashboardParts/DashboardPart-Submit.jsx